module.exports = __webpack_public_path__ + "img/menu-food-2.8995e83f.jpg";